@if (data(); as data) {

  <evland-modal-container (onClose)="onClose()" [title]="data.title" [withFooter]="true">

    <div class="d-flex flex-column gap-2">

      @if (data.message; as message) {
        <div class="message" [innerHTML]="message"></div>
      }

      @if (data.hint; as hint) {
        <div class="hint" [innerHTML]="hint"></div>
      }

      @if (data.tip; as tip) {
        <div class="tip" [innerHTML]="tip"></div>
      }

    </div>

    <div class="d-flex flex-row justify-content-end gap-2" modal-footer>

      <button (click)="onClose()" [class]="'btn ' + cancelButtonClass()">{{ cancelButtonLabel() }}</button>

      <button (click)="onConfirm()" [class]="'btn ' + confirmButtonClass()">{{ confirmButtonLabel() }}</button>

    </div>

  </evland-modal-container>

}
